import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import styled, { keyframes } from 'styled-components';

function StaircaseCard({ id, slug, title, image, alt, description }) {
  return (
    <StyledLink to={slug} description={description}>
      <GatsbyImage image={image} title={title} alt={alt} />
      {description && (
        <Text>
          <StaircaseType id={id}>{title}</StaircaseType>
          <p>{description}</p>
          <p>View More</p>
        </Text>
      )}
    </StyledLink>
  );
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const StyledLink = styled(Link)`
  animation: ${fadeIn} 0.2s ease-in-out forwards;
  border: 0.063rem solid #c4c4c4;
  border-radius: 0.375rem;
  display: grid;
  grid-template-rows: ${({ description }) => (description ? '240px 1fr' : '1fr')};
  height: 100%;
  opacity: 0;
  overflow: hidden;
  text-decoration: none;
  width: 100%;

  @media (width >= 48rem) {
    grid-column: span 3;
  }

  &:hover {
    box-shadow: 0.188rem 0.188rem 0.438rem rgb(189 189 189 / 40%);
    transform: translate3d(0, -0.375rem, 0);
    transition:
      box-shadow 0.2s ease-in-out,
      transform 0.2s ease-in-out;
  }

  &:not(:hover) {
    transform: translate3d(0, 0, 0);
    transition:
      box-shadow 0.2s ease-in-out,
      transform 0.2s ease-in-out;
  }
`;

const Text = styled.div`
  align-items: center;

  /* border-top: 0.063rem solid #C4C4C4; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.313rem 1.25rem 1rem;

  h3,
  p {
    text-align: center;
  }

  h3 {
    font-size: 1.1rem;
    margin-bottom: 0.625em;
  }

  p:last-of-type {
    color: var(--connolly-red);
    font-size: 0.875rem;
    margin-top: 0.1em;
    text-decoration: underline;
  }
`;

const StaircaseType = styled.h3`
  margin-bottom: 0.1rem;
  text-transform: uppercase;
`;

export default StaircaseCard;
